import { render } from "./PresecutorChiefTemplate.vue?vue&type=template&id=93240d96&scoped=true"
import script from "./PresecutorChiefTemplate.vue?vue&type=script&lang=js"
export * from "./PresecutorChiefTemplate.vue?vue&type=script&lang=js"

import "./PresecutorChiefTemplate.vue?vue&type=style&index=0&id=93240d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93240d96"]])

export default __exports__